import React, { useEffect, useState } from "react"
import { HatenaBookmark } from "./hatena-bookmark"
import styled from "styled-components"
import { Icons } from "../icons/icons"
import { SocialButton } from "./social-button"
import { Script } from "gatsby"
import { globalHistory } from "@reach/router"

export const Socials: React.FC = () => {
  const [currentUrl, setCurrentUrl] = useState("");
  const recreateLineButton = (url) => {
    if (typeof window === "undefined") return;
    
    const lineContainer = document.getElementById("line-button-container");
    if (!lineContainer) return;
    
    while (lineContainer.firstChild) {
      lineContainer.removeChild(lineContainer.firstChild);
    }
    
    // URLが変更されてもカウンターを正しく反映させるため、Lineボタンは毎回新規作成する
    const newButton = document.createElement("div");
    newButton.className = "line-it-button";
    newButton.setAttribute("data-lang", "ja");
    newButton.setAttribute("data-type", "share-a");
    newButton.setAttribute("data-env", "REAL");
    newButton.setAttribute("data-url", url);
    newButton.setAttribute("data-color", "default");
    newButton.setAttribute("data-size", "small");
    newButton.setAttribute("data-count", "true");
    newButton.setAttribute("data-ver", "3");
    
    lineContainer.appendChild(newButton);
    
    if (window.LineIt) {
      window.LineIt.loadButton();
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      const url = window.location.href;
      setCurrentUrl(url);     
      recreateLineButton(url);
      
      const unlisten = globalHistory.listen(({ action, location }) => {
        const newUrl = window.location.href;
        if (newUrl !== currentUrl) {
          console.log("URL changed: ", newUrl);
          setCurrentUrl(newUrl);
          setTimeout(() => recreateLineButton(newUrl), 100);
        }
      });
      
      return () => {
        unlisten();
      };
    }
  }, [currentUrl]);

  return (
    <Container>
      {/* X/Twitter */}
      <SocialButton
        icon={<Icons.XIcon width={12} height={12} />}
        style={{ backgroundColor: "black", fill: "white" }}
        onClick={() =>
          window.open(
            "https://twitter.com/intent/tweet?text=" +
              encodeURIComponent(window.location.href || "")
          )
        }
      />

      {/* Facebook */}
      <div
        className="fb-share-button"
        data-href={globalHistory.location.href}
        data-layout="button_count"
        data-size="small"
      >
        <a
          target="_blank"
          rel="noreferrer"
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            globalHistory.location.href || ""
          )}`}
          className="fb-xfbml-parse-ignore"
        >
          Share
        </a>
      </div>

      {/* Hatena */}
      <HatenaBookmark height="20" />

      {/* Line */}
      <div id="line-button-container"></div>

      {/* Pocket */}
      <div style={{ maxWidth: 100, maxHeight: 20 }}>
        <a
          data-pocket-label="pocket"
          data-pocket-count="horizontal"
          className="pocket-btn"
          data-lang="en"
        >
          Pocket
        </a>
      </div>

      {/* Facebook button script */}
      <Script src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v20.0" />

      {/* Line button script */}
      <Script
        src="https://www.line-website.com/social-plugins/js/thirdparty/loader.min.js"
        id="line-sdk"
        strategy="idle"
        onLoad={() => {
          if (typeof window !== "undefined" && window.LineIt) {
            const url = window.location.href;
            recreateLineButton(url);
          }
        }}
      />
      
      {/* Pocket button script */}
      <Script src="https://widgets.getpocket.com/v1/j/btn.js?v=1" />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  height: 32px;
`;

export default Socials;